document.addEventListener("DOMContentLoaded", function () {
  // Scroll page to the top when newsletter subscription captcha window arrives
  if (window.location.href.includes("/challenge#contact_form")) {
    $('html, body').animate({
       scrollTop: $('#main-content').offset().top - 40
    }, 100);
  }


  // Scroll page to the bottom when newsletter submit has errors
  if (window.location.href.includes("=newsletter&form_type=customer")) {
    var newsletterErrorElement = document.querySelector('.newsletter_error');
    newsletterErrorElement.classList.add('show_error');
    $('html, body').animate({
        scrollTop: $('#footer').offset().top
    }, 100);
  }
});



// In the default theme this code was added. For page speed moved this code into this JS by OCS
window.JUST_FETCH_DISCOUNT = async (source) => {
  if(source !== 'cart') return ''
  try{
    const cart = await fetch('./cart.js').then(el => el?.json?.())
    return cart.items.find(el => el.discounts?.[0])?.discounts?.[0]?.title
  }catch{
    return ''
  }
}



// In the default theme this code was added. For page speed moved this code into this JS by OCS
// This code is for Clarity
(function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.defer=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
})(window, document, "clarity", "script", "4366zpo5l7");